[<AutoOpen>]
module Shared.StronglyTypedIds

type UserId = UserId of int

module UserId =
    let unwrap = function UserId i -> i